export default __webpack_public_path__ + "static/suizo_blanco-0f6fff0a530a5adb49a0c565f48ed4a2.svg";